import BaseService from './BaseService'

class UrlService extends BaseService {
  constructor(baseUrl: string) {
    super(baseUrl)
  }

  createShortUrl = async (originalUrl: string, shortBaseUrl?: string) =>
    this.requests.post(`/upsert`, {
      originalUrl,
      shortBaseUrl,
    })
}

const instance = new UrlService(BaseService.servicesConfig.Urls)

export default instance
